<template>
  <div class="cityscape-solution">
    <div class="cityscape-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-2.webp`"
        alt=""
        class="cityscape-solution__card-img"
      />
      <div class="cityscape-solution__card-title" :class="{rightDir}">
        {{ $t('developers') }}
      </div>
      <div
        class="cityscape-solution__card-desc"
        :class="{rightDir}"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('developersDesc') }}
      </div>
    </div>
    <div class="cityscape-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-1.webp`"
        alt=""
        class="cityscape-solution__card-img"
      />
      <div class="cityscape-solution__card-title" :class="{rightDir}">
        {{ $t('designers') }}
      </div>
      <div
        class="cityscape-solution__card-desc"
        :class="{rightDir}"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('designersDesc') }}
      </div>
    </div>
    <div class="cityscape-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-4.webp`"
        alt=""
        class="cityscape-solution__card-img"
      />
      <div class="cityscape-solution__card-title" :class="{rightDir}">
        {{ $t('furnishingCompanies') }}
      </div>
      <div
        class="cityscape-solution__card-desc"
        :class="{rightDir}"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('furnishingCompaniesDesc') }}
      </div>
    </div>
    <div class="cityscape-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-3.webp`"
        alt=""
        class="cityscape-solution__card-img"
      />
      <div class="cityscape-solution__card-title" :class="{rightDir}">
        {{ $t('households') }}
      </div>
      <div
        class="cityscape-solution__card-desc"
        :class="{rightDir}"
        :dir="rightDir ? 'rtl' : 'ltr'"
      >
        {{ $t('householdsDesc') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const rightDir = computed(() => useCookie('lang').value === 'ar');
</script>

<style scoped lang="scss">
::selection {
  background: #00deba; /* Safari */
}

::-moz-selection {
  background: #00deba; /* Firefox */
}

.cityscape-solution {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  .rightDir {
    text-align: right;
  }

  &__card {
    display: flex;
    flex-direction: column;
    padding: 24px;
    background: #fff;
    border: 1px solid #00deba;
    border-radius: 16px;

    &-img {
      //height: 216px;
      //width: 216px;
      width: 100%;
      border-radius: 8px;
      object-fit: cover;
    }

    &-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.02em;
      color: #00deba;
      margin-top: 16px;
    }

    &-desc {
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
      margin-top: 8px;
    }
  }

  @media (max-width: $lg) {
    flex-direction: column;
    display: flex;
    &__card {
      padding: 16px;

      &-img {
        width: 100%;
        height: 364px;
      }

      &-title {
        font-size: 16px;
        line-height: 21px;
        letter-spacing: 0.02em;
        margin-top: 16px;
      }

      &-desc {
        font-size: 15px;
        line-height: 140%;
        letter-spacing: 0.03em;
        margin-top: 4px;
      }
    }
  }
}
</style>
